import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";

const ConfirmationModal = ({
  show,
  onHide,
  isMobileView,
  heading = "",
  messageText = "",
  primaryButtonText = "",
  secondaryButtonText = "",
  onPrimaryClick,
  onSecondaryClick,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        ></button>
        <h2 className="text-center">{heading}</h2>

        <Row>
          <Col xl={12}>
            <p className="mb-5 text-center f-size-16">{messageText}</p>
          </Col>
          <Col xl={6} className={isMobileView ? "order-2" : ""}>
            <Button
              variant="secondary"
              className={
                isMobileView
                  ? "btn w-100 btn-secondary-small mb-0"
                  : "btn w-100 btn-secondary-small"
              }
              onClick={onSecondaryClick}
            >
              {secondaryButtonText}
            </Button>
          </Col>
          <Col xl={6} className={isMobileView ? "order-1" : ""}>
            <Button
              variant="primary"
              className={isMobileView ? "btn w-100 mb-3" : "btn w-100"}
              onClick={onPrimaryClick}
            >
              {primaryButtonText}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
